
import Vue from 'vue'
import App from './App.vue'
import './styles/global.css'
import router from './router'
import './scripts/util'
import './scripts/cache'
import './scripts/mobile_api'
import CustomComponents from './components'
import store from './store'
import { Toast } from 'vant';
import { routerWechatIntercept } from './scripts/auth'
import { goto } from './scripts/goto'
import {pageCacheClear} from './scripts/page_cache'
import Wechat from './scripts/wechat'
import Loading from './scripts/loading'
import './scripts/clipboard'
import { Dialog } from 'vant';

pageCacheClear()
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(CustomComponents)

Vue.config.productionTip = false

let wechatIntercept = routerWechatIntercept(store)
let titleIntercept = function (to) {
	document.title = to.meta.title || '品胜'
}

router.addIntercept(wechatIntercept)
router.addIntercept(titleIntercept)
Vue.use(new Wechat(router))
Vue.use(goto);
new Vue({
	render: h => h(App),
	store,
	router
}).$mount('#app')
